import { IS_WHITELABELING } from 'src/constants';
import { clickApiDocs, clickProductDocs, onClickGuidelines } from './tracks';
import {
  DocumentationCardType,
  HelpAndDocumentationContextValue,
} from './types';

export const ListDocumentationWording: DocumentationCardType[] = [
  ...(!IS_WHITELABELING
    ? [
        {
          title: 'faq_product_documentation',
          description: 'faq_product_documentation_desc',
          track: clickProductDocs,
        },
      ]
    : []),
  {
    title: 'faq_api_documentation',
    description: 'faq_api_documentation_desc',
    track: clickApiDocs,
  },
  ...(!IS_WHITELABELING
    ? [
        {
          title: 'faq_product_guideline',
          description: 'faq_product_guideline_desc',
          track: onClickGuidelines,
        },
      ]
    : []),
];

export const defaultContextValue: HelpAndDocumentationContextValue = {
  data: [],
  selectedCategory: undefined,
  selectedArticle: undefined,
  isSideModalArticleShowed: false,
  isSideModalCategoryShowed: false,
  indexCategory: 0,
  isSearching: false,
  onClickCategory: () => {},
  onClickArticle: () => {},
  onCloseArticleSideModal: () => {},
  onCloseCategorySideModal: () => {},
  getSuggestion: function (searchQuery: string): string[] {
    return [searchQuery];
  },
  onSuggestionClick: function (searchQuery: string): void {
    searchQuery;
  },
  prefixSubCategory: [],
  customCategoryHeader: null,
  customCategoryTitle: null,
  isUseCategoryTitleAsHeader: false,
};
